function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from '../../../comun/services/acceso-datos';
import './panel-preguntas.scss';
import { deburr, forEach, lowerCase, mapValues, pickBy, trim } from 'lodash';
export var TIPO_F = {
  ROW: {
    t: 'ROW',
    visible: true,
    pad: '                         ',
    mask: 8192
  },
  //
  SELECT: {
    t: 'SELECT',
    visible: true,
    pad: '                   ',
    mask: 4096
  },
  //
  TEXT: {
    t: 'TEXT',
    visible: true,
    pad: '                       ',
    mask: 2048
  },
  YESNO: {
    t: 'YESNO',
    visible: true,
    pad: '                     ',
    mask: 1024
  },
  MEMO: {
    t: 'MEMO',
    visible: true,
    pad: '                       ',
    mask: 512
  },
  FILE: {
    t: 'FILE',
    visible: true,
    pad: '                       ',
    mask: 256
  },
  MULTIPLE: {
    t: 'MULTIPLE',
    visible: true,
    pad: '               ',
    mask: 128
  },
  PARAM: {
    t: 'PARAM',
    visible: true,
    pad: '                     ',
    mask: 64
  },
  PARAM2: {
    t: 'PARAM2',
    visible: true,
    pad: '                   ',
    mask: 32
  },
  DATE: {
    t: 'DATE',
    visible: true,
    pad: '                       ',
    mask: 16
  },
  EMAIL: {
    t: 'EMAIL',
    visible: true,
    pad: '                     ',
    mask: 8
  },
  ERROR: {
    t: 'ERROR',
    visible: false,
    pad: '                    ',
    mask: 4
  },
  NUMBER: {
    t: 'NUMBER',
    visible: true,
    pad: '                   ',
    mask: 2
  },
  PARAMOCULTO: {
    t: 'PARAMOCULTO',
    visible: true,
    pad: '         ',
    mask: 1
  }
};
var FLAGS_MASK_LIST = [{
  p: 'required',
  pad: '           ',
  mask: 32,
  t: 'Required',
  icon: 'star'
}, {
  p: 'multiple',
  pad: '           ',
  mask: 16,
  t: 'Allow multiple',
  icon: 'content_copy'
}, {
  p: 'listado',
  pad: '            ',
  mask: 8,
  t: 'In listing',
  icon: 'grid_on'
}, {
  p: 'buscar',
  pad: '             ',
  mask: 4,
  t: 'Allow search',
  icon: 'search'
}, {
  p: 'keep_history',
  pad: '       ',
  mask: 2,
  t: 'Keep when delete Record',
  icon: 'update'
}, {
  p: 'omit_history_match',
  mask: 1,
  t: 'Skip when searching for matches in history',
  icon: 'layers_clear'
}];
var FLAGS_MASK = pickBy(FLAGS_MASK_LIST, function (p) {
  return p.p;
});
var PanelPreguntasComponentCtrl = /*#__PURE__*/function () {
  PanelPreguntasComponentCtrl.$inject = ["$log", "NotifService", "$element", "$timeout", "$q", "AccesoDatos"];
  function PanelPreguntasComponentCtrl($log,
  //
  NotifService, $element, $timeout, $q, AccesoDatos) {
    _classCallCheck(this, PanelPreguntasComponentCtrl);
    _defineProperty(this, "pregsState", new PregsState());
    _defineProperty(this, "filtros", {
      filterq: null,
      flags: FLAGS_MASK_LIST.map(function (def) {
        return {
          def: def,
          activo: false
        };
      }),
      flags_mask: 0,
      tipo: mapValues(TIPO_F, function (t) {
        return {
          def: t,
          activo: false
        };
      }),
      tipo_mask: 0
    });
    _defineProperty(this, "hayFiltros", false);
    this.$log = $log;
    this.NotifService = NotifService;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$q = $q;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelPreguntasComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[PanelPreguntasComponentCtrl] onInit');
      this.refreshQ(false);
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this = this;
      this.$timeout(function (_) {
        var searchinput = _this.$element.find('#searchbox');
        if (searchinput) {
          searchinput[0].focus();
        }
      }, 50);
    }
  }, {
    key: "refreshQ",
    value: function refreshQ() {
      var _this2 = this;
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (delay) {
        this.pregsState.conPreguntas([]);
        this.$timeout(function () {
          return _this2._leerPregs();
        }, 200);
      } else {
        this._leerPregs();
      }
    }
  }, {
    key: "_leerPregs",
    value: function _leerPregs() {
      var _this3 = this;
      this.$q.all([
      //
      this.AccesoDatos.Preg_CLIENT.listaPreguntas(), this.AccesoDatos.MainQuestions_CLIENT.todasLasPregPrincipales()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          pregsList = _ref2[0],
          mainPregsList = _ref2[1];
        _this3.pregsState.conPreguntas(pregsList.list.map(function (p) {
          return new PregState(p);
        }));
        _this3.pregsState.storeMainQ = new StoreMainQ(mainPregsList);
      });
    }
  }, {
    key: "sinFiltro",
    value: function sinFiltro() {
      var _this4 = this;
      this.filtros.filterq = null;
      forEach(this.filtros.flags, function (f) {
        f.activo = false;
        return true;
      });
      this.filtros.flags_mask = 0;
      forEach(this.filtros.tipo, function (_, key) {
        _this4.filtros.tipo[key].activo = false;
      });
      this.filtros.tipo_mask = 0;
      this.filtrarQ();
    }
  }, {
    key: "filtroText",
    value: function filtroText(t) {
      this.filtros.filterq = t;
      this.filtrarQ();
    }
  }, {
    key: "filtrarQ",
    value: function filtrarQ() {
      this.hayFiltros = !!(trim(this.filtros.filterq) || this.filtros.flags_mask || this.filtros.tipo_mask);
      this.pregsState.filtrarPregs(this.filtros);
    }
  }, {
    key: "filtrarFlag",
    value: function filtrarFlag(flag) {
      flag.activo = !flag.activo;
      this.filtros.flags_mask ^= flag.def.mask;
      this.filtrarQ();
    }
  }, {
    key: "filtrarTipo",
    value: function filtrarTipo(flag) {
      flag.activo = !flag.activo;
      this.filtros.tipo_mask ^= flag.def.mask;
      this.filtrarQ();
    }
  }, {
    key: "nuevaPregunta",
    value: function nuevaPregunta() {
      this.pregsState.nuevaPreg(new PregState({
        data: {
          subpreg: false
        }
      }));
    }
  }]);
}();
export var StoreMainQ = /*#__PURE__*/_createClass(function StoreMainQ(list) {
  _classCallCheck(this, StoreMainQ);
  this.list = list;
});
var DEF_TIPO = TIPO_F;
export var PregState = /*#__PURE__*/function () {
  function PregState(datapreg) {
    var _datapreg$subp;
    _classCallCheck(this, PregState);
    _defineProperty(this, "_search", '');
    _defineProperty(this, "_flagsMask", 0);
    _defineProperty(this, "_tipoMask", 0);
    this.datapreg = datapreg;
    var _t = "".concat(datapreg.data.texto_en, " ").concat(datapreg.data.tipoq, " ").concat(datapreg.data.explanation);
    var _tt = (_datapreg$subp = datapreg.subp) !== null && _datapreg$subp !== void 0 && _datapreg$subp.length ? _t + ' ' + datapreg.subp.map(function (subp) {
      return "".concat(subp.data.texto_en);
    }).join(' ') : _t;
    this._search = lowerCase(deburr(_tt));
    this._flagsMask = this.__flags(datapreg.data);
    this._tipoMask = this.__tipo(datapreg.data);
  }
  return _createClass(PregState, [{
    key: "__flags",
    value: function __flags(data) {
      // reduce(PROPS_MASK, )

      var _v = 0;
      for (var _i = 0, _FLAGS_MASK_LIST = FLAGS_MASK_LIST; _i < _FLAGS_MASK_LIST.length; _i++) {
        var _p = _FLAGS_MASK_LIST[_i];
        _v = _v | (data[_p.p] ? _p.mask : 0);
      }
      return _v;
    }
  }, {
    key: "__tipo",
    value: function __tipo(data) {
      if (data.tipoq) {
        var def = DEF_TIPO[data.tipoq];
        if (def) {
          return def.mask;
        }
      }
      return 0;
    }
  }, {
    key: "_matchText",
    value: function _matchText(t) {
      return this._search.includes(t);
    }
  }, {
    key: "_matchFlags",
    value: function _matchFlags(mask) {
      // return (this._flagsMask & mask) == mask  // cumple todo

      return this._flagsMask & mask; // cumple alguno
    }
  }, {
    key: "_matchTipo",
    value: function _matchTipo(mask) {
      return this._tipoMask & mask; // cumple alguno
    }
  }]);
}();
export var PregsState = /*#__PURE__*/function () {
  function PregsState() {
    _classCallCheck(this, PregsState);
    _defineProperty(this, "list", []);
    _defineProperty(this, "visibles", []);
  }
  return _createClass(PregsState, [{
    key: "conPreguntas",
    value:
    // -----

    function conPreguntas(list) {
      this.visibles = this.list = list;
    }
  }, {
    key: "nuevaPreg",
    value: function nuevaPreg(p) {
      this.list.push(p);
      if (this.list !== this.visibles) {
        this.visibles.push(p);
      }
    }
  }, {
    key: "filtrarPregs",
    value: function filtrarPregs(f) {
      if (f.filterq || f.flags_mask || f.tipo_mask) {
        var _f = deburr(lowerCase(f.filterq));
        this.visibles = this.list.filter(function (p // //
        ) {
          return (!f || p._matchText(_f)) && (!f.flags_mask || p._matchFlags(f.flags_mask)) && (!f.tipo_mask || p._matchTipo(f.tipo_mask));
        });
      } else {
        this.visibles = this.list;
      }
    }
  }]);
}();
angular.module('candidato').component('panelPreguntas', {
  bindings: {},
  controller: PanelPreguntasComponentCtrl,
  template: require('./panel-preguntas.component.html')
  // templateUrl: './panel-preguntas.component.html',
});